import { getMenu } from '@/api/app'
import router from '@/router'
const user = {
  state: {
    roles: [], // 所有权限的列表
    isAdmin: '', // 是否管理员
    uuid: '', // 账号id
    sellerId: '', // 账号id
    sellerName: '', // 账号
    userName: '', // 姓名
    companyName: '', // 企业名
    znbbCompanyId: '', // 智能报表companyid
    vipCount: 0
  },
  mutations: {
    SET_ROLES: (state, list) => {
      state.roles = list
    },
    SET_IS_ADMIN: (state, id) => {
      state.isAdmin = id
    },
    SET_ADMIN_NAME: (state, Adminname) => {
      state.sellerName = Adminname
    },
    SET_VIP_COUNT: (state, vipCount) => {
      state.vipCount = vipCount
    }
  },
  actions: {
    formMenu({ commit }, resolve) {
      getMenu().then(res => {
        if (res.code === 0) {
          commit('SET_IS_ADMIN', res.result.admin_is_super)
          commit('SET_ADMIN_NAME', res.result.admin_name)
          const tmp = ['null']
          if (res.result.premissions.length !== 0) {
            res.result.premissions.map(menu => {
              if (menu.children && menu.children.length !== 0) {
                menu.children.map(submenu => {
                  if (['产品标准库', '企业标准库', '医药从业人员'].includes(menu.name)) {
                    submenu.tab = 'libTab'
                  } else if (['统计结算'].includes(menu.name)) {
                    submenu.tab = 'reportTab'
                  } else {
                    submenu.tab = 'dshTab'
                  }
                  tmp.push(submenu)
                })
              }
              tmp.push({
                name: menu.name,
                id: menu.id
              })
            })
          } else {
            const routeName = router.history.current.name
            if (routeName !== 'emptyRole' && routeName !== 'newPassword') {
              router.push({ name: 'emptyRole' })
            }
          }
          commit('SET_ROLES', tmp)
          resolve()
        } else {
          router.push({ name: 'login' })
        }
      })
    },
    emptyRoles({ commit }, list) {
      commit('SET_ROLES', list)
    }
  }
}

export default user
